import React from 'react';
import { useIntl } from 'umi';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { IChildProp } from '@intelligence/components/Form/type';

export default function EmptyValue(props: {
  showItem: IChildProp;
}) {
  const { formatMessage } = useIntl();
  const { showItem } = props;
  return (
    <div className="dbi-cascader-select-button-flex">
      <img
        className="dbi-cascader-common-icon"
        src={getDataSourceIcon(showItem.icon)}
      />
      <span>{showItem.labelKey ? formatMessage({ id: showItem.labelKey }) : showItem.label}</span>
    </div>
  );
}
